import React, { memo } from 'react';
import cn from 'classnames';

import SingleSelect, { SingleSelectProps } from 'components/SingleSelect';

import styles from './Dropdown.module.scss';

export interface DropdownProps extends SingleSelectProps {
  /*label*/
  label?: string;
  /** has primary background? */
  hasPrimaryBg?: boolean;
  /** triggerButtonClassName */
  triggerButtonClassName?: string;
  /** hide chevron icon on disabled */
  hideChevronIconOnDisabled?: boolean;
  /** className for label style*/
  labelClassName?: string | null;
}

export const Dropdown: React.FC<DropdownProps> = memo(
  (props: DropdownProps) => {
    const {
      label = props.title,
      className,
      style,
      hasPrimaryBg,
      triggerButtonClassName,
      labelClassName = '',
    } = props;
    const contentClassNames = cn(
      {
        [styles.Dropdown]: true,
      },
      className
    );

    const labelClassNames = cn(
      {
        [styles.DropdownLabel]: true,
      },
      labelClassName
    );

    return (
      <div className={contentClassNames} style={style} data-testid="Dropdown">
        {label ? <div className={labelClassNames}>{label}</div> : null}
        <SingleSelect
          {...props}
          className={styles.DropdownList}
          triggerButtonClassName={cn(
            styles.DropdownTriggerButton,
            {
              [styles.DropdownTriggerButtonPrimary]: hasPrimaryBg,
            },
            triggerButtonClassName
          )}
        />
      </div>
    );
  }
);

Dropdown.displayName = 'Dropdown';
